export const GOOGLE_ANALYTICS_ID = 'UA-167995172-1';
